import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { APP_CONFIG } from '../../../app.config';
import { EntityType } from '../../../shared/enums/entity-type.enum';
import { RequestService } from '../../../shared/services/request.service';
import { KYCLink } from './models/kyc-link-model';
import { PaymentAccount } from './models/payment-account.model';
import {
  PaymentAccountFilter,
  PaymentStatement,
  PaymentStatementResponse,
} from './models/payment-statement.model';
import { WithdrawalConfig } from './models/withdrawal-config.model';

@Injectable()
export class PaymentAccountService {
  private kycData: { storeId: number; linkData: KYCLink };

  constructor(private requestService: RequestService) {}

  async getPaymentAccount(storeId: number): Promise<PaymentAccount> {
    const urlRequest = `${APP_CONFIG.WEBSERVICE.PAYMENT_ACCOUNT_BALANCE}?entity=STORE&entityId=${storeId}`;
    return await this.requestService.getData(urlRequest);
  }

  async getStatements(
    filter: PaymentAccountFilter,
    isPayables: boolean
  ): Promise<PaymentStatementResponse> {
    let api = isPayables
      ? APP_CONFIG.WEBSERVICE.PAYMENT_ACCOUNT_PAYBLES_STATEMENTS
      : APP_CONFIG.WEBSERVICE.PAYMENT_ACCOUNT_STATEMENTS;
    let urlRequest = `${api}?${this.requestService.buildUrlParams(filter)}`;
    console.log(urlRequest);
    const response = await this.requestService.getData(urlRequest);
    let statements = new PaymentStatementResponse(response);
    statements.data = [];
    if (response && response.data) {
      response.data.forEach((item) => {
        statements.data.push(new PaymentStatement(item));
      });
    }
    return statements;
  }

  async getWithdrawalConfig(storeId: number): Promise<WithdrawalConfig> {
    const urlRequest = `${APP_CONFIG.WEBSERVICE.WITHDRAWAL_CONFIG}?entity=STORE&entityId=${storeId}`;
    return await this.requestService.getData(urlRequest);
  }

  async updateWithdrawalConfig(config: WithdrawalConfig): Promise<void> {
    await this.requestService.putData(APP_CONFIG.WEBSERVICE.WITHDRAWAL_CONFIG, config.toJson());
  }

  async withdraw(amount: number, storeId: number): Promise<void> {
    let data = {
      value: amount,
      entityId: storeId,
      entity: EntityType.STORE,
    };
    await this.requestService.postData(APP_CONFIG.WEBSERVICE.WITHDRAW, data);
  }

  async generateKycLink(storeId: number): Promise<KYCLink> {
    if (this.kycData && this.kycData.storeId == storeId) {
      const expiresAt = moment(this.kycData.linkData.expiresAt);
      if (expiresAt.isAfter(moment())) {
        return this.kycData.linkData;
      }
    }
    const urlRequest: string = this.requestService.buildUrlPathParams(
      { storeId: storeId },
      APP_CONFIG.WEBSERVICE.GENERATE_KYC_LINK
    );
    const response: KYCLink = await this.requestService.getData(urlRequest);
    if (response && response.base64QrCode) {
      response.base64QrCode = `data:image/svg+xml;base64,${response.base64QrCode}`;
    }
    this.kycData = {
      storeId: storeId,
      linkData: response,
    };
    return this.kycData.linkData;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/receivables/payment-account/payment-account.service.ts